import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import InventoryAdjustServices from "./InventoryAdjustServices";

const initialState = {
  inventoryAdjusts: [],
  inventoryAdjust: null,
  isError: false,
  isSuccess: false,
  isSuccessCreate: false,
  isLoading: false,
  message: "",
};
export const inventoryAdjust = createAsyncThunk(
  "inventoryAdjust/inventoryAdjust",
  async (inventoryAdjustData, thunkAPI) => {
    try {
      return await InventoryAdjustServices.inventoryAdjust(inventoryAdjustData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getInventoryAdjusts = createAsyncThunk(
  "inventoryAdjust/getInventoryAdjusts",
  async (_, thunkAPI) => {
    try {
      return await InventoryAdjustServices.getInventoryAdjusts();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const inventoryAdjustSlice = createSlice({
  name: "inventoryAdjust",
  initialState,
  reducers: {
    RESET_INVENTORY_ADJUST(state) {
      state.isError = false;
      state.isSuccess = false;
      state.isSuccessCreate = false;
      state.isLoading = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(inventoryAdjust.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(inventoryAdjust.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessCreate = true;
        state.inventoryAdjust = action.payload.data;
        toast.success(action.payload.message);
      })

      .addCase(inventoryAdjust.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(getInventoryAdjusts.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getInventoryAdjusts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.inventoryAdjusts = action.payload.data;
      })

      .addCase(getInventoryAdjusts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      });
  },
});

export const { RESET_INVENTORY_ADJUST } = inventoryAdjustSlice.actions;
export const selectInventoryAdjusts = (state) =>
  state.inventoryAdjust.inventoryAdjusts;
export const selectCreateInventoryAdjustSuccess = (state) =>
  state.inventoryAdjust.isSuccessCreate;

export default inventoryAdjustSlice.reducer;
